export var Variant;
(function (Variant) {
    Variant["error"] = "error";
    Variant["warning"] = "warning";
    Variant["success"] = "success";
    Variant["info"] = "info";
})(Variant || (Variant = {}));
